import SectionTitle from '../ui/section-title'

import PublicPageReviewCardSkeleton from './public-page-review-card-skeleton'

const PublicPageReviewListSkeleton = () => {
  return (
    <section className="mb-6">
      <SectionTitle
        title="Reviews"
        rightContent={<div className="text-base font-semibold text-muted">Calculating...</div>}
      />
      <div className="mt-4 grid grid-cols-2 gap-4">
        {[1, 2, 3, 4].map((i) => (
          <PublicPageReviewCardSkeleton key={i} />
        ))}
      </div>
    </section>
  )
}

export default PublicPageReviewListSkeleton
